// extracted by mini-css-extract-plugin
export default {"filter":"stock_filter_filter__hrNcf","Mui-focused":"stock_filter_Mui-focused__TX+0z","label":"stock_filter_label__23IMa"};